import $ from 'jquery';
import 'slick-carousel';
import BaseComponent from './baseComponent';

/**
 * Create a slick-slider.
 * http://kenwheeler.github.io/slick/
 */
export default class imageSlider extends BaseComponent {
  /**
   * Public constructor
   *
   * @param options
   */
  constructor(options) {
    super(options);

    this.activeClass = options.activeClass || null;

    return this;
  }

  renderSliders() {
    this.$sliders = $('[data-image-slider]');

    $.each(this.$sliders, (index, element) => {
      const $slider = $(element);

      $slider.slick({
        infinite: true,
        slidesToShow: 1,
        dots: true,
        speed: 250,

        // Add own html for our prev/next-buttons
        prevArrow: '<button type="button" class="button-plain slick-arrow -prev"><i class="icon-arrow-up arrow"></i></button>',
        nextArrow: '<button type="button" class="button-plain slick-arrow -next"><i class="icon-arrow-down arrow"></i></button>',
      });

      $slider.addClass(this.activeClass);
    });
  }

  /**
   * Initialize function
   */
  init() {
    this.renderSliders();

    document.addEventListener('refreshImageSliders', () => {
      $.each(this.$sliders, (index, element) => {
        const $slider = $(element);
        $slider.removeClass(this.activeClass);
        $slider.slick('unslick');
      });

      this.renderSliders();
    });
  }
}
